//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import { mapGetters, mapState } from "vuex";
import { date, uid } from "quasar";
import { APP_DATE_DOT_DMY_FORMAT } from "@/assets/js/appConfig";
import {
    previewDocument,
    previewDocumentMobile,
    convertAndFormatTimeToLocal
} from "@/assets/js/appFunc";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import TabComponents from "@/components/Admin/ProcessInspector/mixins/tab-components";

export default {
    components: { AQMenu, AQCheckbox },
    mixins: [TabComponents],
    props: {
        processInstance: String,
        applicationId: String,
        perspectiveId: String,
        hasCheckbox: { type: Boolean, required: false, default: false },
        resetCheckbox: { type: Boolean, required: false, default: false }
    },

    data() {
        return {
            uploadedFiles: [],
            moreOptions: null,
            popoverOpnd: false,
            documentsSelectedList: [],
            APP_DATE_DOT_DMY_FORMAT,
            checkAll: false,
            hasIndeterminate: false,
            timer: null,
            showMenu: []
        };
    },
    computed: {
        ...mapState("diagrams", ["documentsList"]),
        ...mapGetters("userProfile", ["getUserId"]),
        ...mapState("components", ["isSmallScreen", "taskId"]),
        docMenuOptions() {
            return [{ label: this.$t("documents.download") }];
        }
    },
    watch: {
        resetCheckbox: {
            handler() {
                this.documentsSelectedList = [];
                this.checkAll = false;
            },
            immediate: true
        },
        documentsSelectedList: {
            handler(value) {
                if (value.length && this.documentsList.length) {
                    this.hasIndeterminate = value.length < this.documentsList.length;
                    this.checkAll = value.length === this.documentsList.length || "indeterminate-check";
                } else {
                    this.hasIndeterminate = false;
                    this.checkAll = false;
                }
            },
            immediate: true
        }
    },

    mounted() {
        this.$store.dispatch("diagrams/getDocuments", { processInstance: this.processInstance, taskId: this.taskId, appId: this.applicationId, perspectiveId: this.perspectiveId }).then((rsp) => {
            const { data } = rsp;
            this.$store.commit("diagrams/setDocumentsList", data);
            this.$emit("disableOption", !data.length);
        });
        this.$store.dispatch("userProfile/getUserDetails");
        const self = this;
        if (this.$refs.dropzoneWrapper) {
            this.$refs.dropzoneWrapper.addEventListener("dragenter", () => {
                self.$refs.dropzone.style.visibility = "";
                self.$refs.dropzone.style.opacity = 1;
            });

            this.$refs.dropzoneWrapper.addEventListener("dragleave", (
                e
            ) => {
                e.preventDefault();
                self.$refs.dropzone.style.visibility = "hidden";
                self.$refs.dropzone.style.opacity = 0;
            });

            this.$refs.dropzoneWrapper.addEventListener("dragover", (
                e
            ) => {
                e.preventDefault();
                self.$refs.dropzone.style.visibility = "";
                self.$refs.dropzone.style.opacity = 1;
            });

            this.$refs.dropzoneWrapper.addEventListener("drop", (e) => {
                e.preventDefault();
                self.$refs.dropzone.style.visibility = "hidden";
                self.$refs.dropzone.style.opacity = 0;

                const { files } = e.dataTransfer;
                self.uploadFiles(files);
            });
        }
    },
    destroyed() {
        if (this.$refs.dropzoneWrapper) {
            this.$refs.dropzoneWrapper.removeEventListener();
        }
    },
    methods: {
        convertAndFormatTimeToLocal,
        startTouch(id) {
            let checkLong = false;
            if (!this.hasCheckbox) {
                this.timer = setTimeout(() => {
                    this.$emit("longTouch", true);
                    checkLong = true;
                }, 500);
                setTimeout(() => {
                    if (checkLong) {
                        this.documentsSelectedList.push(id);
                        this.$emit("showDocumentsList", this.documentsSelectedList);
                    }
                }, 550);
            }
        },
        moveTouch() {
            if (this.timer) {
                clearTimeout(this.timer);
            }
        },
        endTouch() {
            if (this.timer) {
                clearTimeout(this.timer);
            }
        },
        convertSize(value) {
            let newSize = "";
            if (value < 1000000) {
                newSize = value / 1000;
                return `${newSize.toFixed(2)} KB`;
            }
            newSize = value / 1000000;
            return `${newSize.toFixed(2)} MB`;
        },
        showList() {
            this.$emit("showDocumentsList", this.documentsSelectedList);
        },
        addClass(file, index) {
            this.popoverOpnd = true;
            const elem = document.getElementById(`popoverBtn${index}`);
            elem.classList.add("vert-style-hover");
        },
        removeClass(index) {
            this.popoverOpnd = false;
            const elem = document.getElementById(`popoverBtn${index}`);
            elem.classList.remove("vert-style-hover");
        },
        download(id) {
            if (!/iPad|iPhone|iPod/.test(navigator.userAgent)) {
                window.open(`/data/attachment/download/attachment/${id}`);
            } else {
                window.location.href = `/data/attachment/download/attachment/${id}`;
            }
        },
        openPreview(file) {
            if (file.contentType === "application/pdf" && !this.hasCheckbox) {
                this.$store
                    .dispatch("diagrams/getPreviewDocument", file.id)
                    .then(rsp => {
                        if (this.isSmallScreen) {
                            previewDocumentMobile(rsp);
                        } else {
                            let previewWindow;
                            setTimeout(() => {
                                previewWindow.document.title = file.fileName;
                            }, 100); 
                            const fileType = "application/pdf";
                            const blob = new Blob([rsp.data], { type: fileType });
                            const pdfObject = document.createElement("object");
                            pdfObject.setAttribute("type", fileType);
                            pdfObject.setAttribute("data", URL.createObjectURL(blob));
                            pdfObject.style.cssText = "width:100%;height:100%;position:fixed;top:0;bottom:0;left:0;right:0;";
                            previewWindow = window.open(pdfObject.data, "_blank");
                        }
                    });
            }
        },
        // Will be implemented later
        // deleteFile(id) {
        //     this.$q.dialog({
        //         title: this.$t("documents.deleteTitle"),
        //         message: this.$t("documents.deleteBody"),
        //         ok: {
        //             color: "primary",
        //             label: this.$t("dataModel.modal.deleteBtnDlt")
        //         },
        //         cancel: {
        //             outline: true,
        //             label: this.$t("dataModel.modal.deleteBtnCancel")
        //         }
        //     })
        //     .then(() => {
        //         for(let i=0;i<this.documentsList.length;i++) {
        //             if(this.documentsList[i].id===id) {
        //                 this.documentsList.splice(i,1);
        //             }
        //         }
        //         this.$store.dispatch("diagrams/deleteDocument", id);
        //     })
        //     .catch(() => {
        //     });
        // },
        selectAllDocs() {
            if (this.documentsSelectedList.length === this.documentsList.length) {
                this.documentsSelectedList = [];
            } else {
                this.documentsSelectedList = this.documentsList.map(elem => elem.id);
            }
            this.$emit("showDocumentsList", this.documentsSelectedList);
        },
        upload() {
            this.$refs.hiddenInput.click();
        },
        changeMoreVert(file) {
            if (!this.hasCheckbox) {
                this.moreOptions = file;
            }
        },
        leaveDocContainer() {
            if (!this.popoverOpnd) {
                this.moreOptions = null;
            }
        },
        uploadFiles(f) {
            for (let i = 0; i < f.length; i++) {
                if (f[i].type !== "application/pdf") {
                    alert(
                        `${this.$t("admin.processInspector.sorry")
                        } ${
                            f[i].type
                        } ${
                            this.$t(
                                "admin.processInspector.notAcceptedFileType"
                            )}`
                    );
                    continue;
                } else if (this.uploadedFiles.length > 0) {
                    if (
                        !this.checkDuplicateFile(
                            f[i].name.substr(
                                0,
                                f[i].name.lastIndexOf(".pdf")
                            )
                        )
                    ) {
                        this.loadFiles(f[i]);
                    }
                } else {
                    this.loadFiles(f[i]);
                }
            }
        },
        loadFiles(file) {
            const name = file.name.substr(0, file.name.lastIndexOf(".pdf"))
                        || file.name;
            const { size } = file;
            const date = file.lastModifiedDate;

            this.uploadedFiles.unshift({
                fileSize: size,
                fileName: name,
                fileDate: date,
                fileId: uid()
            });
        },
        checkDuplicateFile(filename) {
            if (this.uploadedFiles.find(el => el.fileName === filename)) {
                alert(`Duplicate file: ${filename}`);
                return true;
            }
            return false;
        },
        menuActions(event, fileId) {
            for (let i = 0; i < event.length; i++) {
                if (event[i].label === this.$t("documents.download")) {
                    this.download(fileId);
                }
            }
        }
    },
    filters: {
        date: value => {
            if (!value) return "";
            return date.formatDate(new Date(), APP_DATE_HYPHEN_FORMAT);
        },
        size: value => {
            if (value == 0) return "0 Bytes";
            const k = 1000;
            const dm = 2;
            const sizes = ["Bytes", "KB", "MB"];
            const i = Math.floor(Math.log(value) / Math.log(k));
            return (
                `${parseFloat((value / Math.pow(k, i)).toFixed(dm))
                } ${
                    sizes[i]}`
            );
        },
        name: value => value.replace(/\.[^/.]+$/, ""),
        extension: value => {
            const formattedValue = value.split(".");
            return formattedValue.length === 1
                ? "other"
                : formattedValue[formattedValue.length - 1];
        }
    }
};
